
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-in-the-workplace-benefits",
      function () {
        return require("private-next-pages/ai-in-the-workplace-benefits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-in-the-workplace-benefits"])
      });
    }
  